import { render, staticRenderFns } from "./PitStopDoSaber.vue?vue&type=template&id=6841d5b4"
import script from "./PitStopDoSaber.vue?vue&type=script&lang=js"
export * from "./PitStopDoSaber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports